import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  objectiveCompetencyPillarsLength: 0,
  objectiveCompetencyPillars: [],
  objectiveCompetencyPillar: {},
  objectiveCompetencyPillarError: "",
  formError: "",
};

export default function ObjectiveCompetencyPillarReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_OBJECTIVE_COMPETENCY_PILLAR:
      return { ...state, loading: action.payload };
    case actions.LOADING_OBJECTIVE_COMPETENCY_PILLAR_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_OBJECTIVE_COMPETENCY_PILLAR:
      return { ...state, saveLoading: action.payload };
    case actions.GET_OBJECTIVE_COMPETENCY_PILLAR:
      return {
        ...state,
        objectiveCompetencyPillars: action.payload.objectiveCompetencyPillars,
        objectiveCompetencyPillarsLength: action.payload.objectiveCompetencyPillarsLength,
      };
    case actions.GET_OBJECTIVE_COMPETENCY_PILLAR_BY_ID:
      return {
        ...state, objectiveCompetencyPillar: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.OBJECTIVE_COMPETENCY_PILLAR_FAIL:
      return { ...state, objectiveCompetencyPillarError: action.payload };
    default:
      return state;
  }
}
